export default __webpack_public_path__ + "static/media/shake.cad6a174.png";